import { useMutationError, useQueryError } from '@versita/frontend/api-utils';
import { useEffect, useState } from 'react';
import { toast } from 'react-hot-toast';
import { telemetry } from './services/telemetry';
import * as Sentry from '@sentry/react';
import { useAuthError } from '@versita/frontend/auth-web';

export const NotifyErrors = () => {
  const [userInformed, setUserInformed] = useState(false);
  const [queryError] = useQueryError();
  const [mutationError] = useMutationError();
  const [authError] = useAuthError();

  useEffect(() => {
    if (authError) {
      Sentry.addBreadcrumb({
        type: 'Auth Error',
        level: 'error',
        message: 'Authentication error',
        data: authError,
      });
      telemetry.trackException(
        { exception: new Error('Authentication error') },
        authError,
      );
    }
  }, [authError]);

  useEffect(() => {
    if (mutationError) {
      Sentry.addBreadcrumb({
        type: 'error',
        level: 'error',
        message: 'Error saving data',
        data: mutationError,
      });
      telemetry.trackException(
        { exception: new Error('Error saving data') },
        mutationError,
      );
      if (!userInformed) {
        toast.error(
          "We're having trouble saving some data. Please try again later.",
        );
        setUserInformed(true);
      }
    }
    if (queryError) {
      Sentry.addBreadcrumb({
        type: 'error',
        level: 'error',
        message: 'Error fetching data',
        data: queryError,
      });
      telemetry.trackException(
        { exception: new Error('Error fetching data') },
        queryError,
      );
      if (!userInformed) {
        toast.error(
          "We're having trouble loading some information. Please try again later.",
        );
        setUserInformed(true);
      }
    }
  }, [queryError, mutationError, userInformed]);
  return null;
};
